import { workOrderTypeList } from "@repo/api";
import { FilterCheckbox } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const WorkOrderTypeFilter = ({ actions, filters }: FilterItemsProps) => {
  return (
    <FilterListContainer id="work-order-type-filter">
      {workOrderTypeList.map((type) => (
        <FilterCheckbox
          key={type}
          id={type}
          value={type}
          label={type ?? "-"}
          checked={isChecked(filters.workOrderType, type)}
          onCheckFilter={actions.setWorkOrderType}
        />
      ))}
    </FilterListContainer>
  );
};
